import { Component, OnInit } from '@angular/core';
import { CurrencyRateService } from '../currency-rate.service';
import { CurrencyService } from '../../currencies/currency.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { Location } from '@angular/common';

@Component({
  selector: 'app-currency-rate-crud',
  templateUrl: './currency-rate-crud.component.html',
  styleUrls: ['./currency-rate-crud.component.css'],
  providers: [ CurrencyRateService, CurrencyService ]
})
export class CurrencyRateCrudComponent implements OnInit {

	 currencyRate: any;
   id: any = null;
	 _store_id: any;
   _store_name: any;
   loading: boolean = false;
   button_caption="Добавить";
   button_icon:string ="fa fa-save";
   msgs: Message[] = [];
   selectedCurrency: string;
   arrayCurrencyIso: any =[];

  constructor(
  	private currencyRateService: CurrencyRateService,
    private currencyService: CurrencyService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
  	private global: GlobalDataService) { 

    activatedRoute.params.subscribe(params=>{this.id = params['id']});


    this.currencyService.getCurrency().subscribe(response=>{this.currencyRate.currencies=response['data'].map(function(value: any){
          return {label:value.name, value: value.id, code: value.code};
          });
    }); 

    
    if(this.id){
      this.loading=true;   
         this.currencyRateService.getCurrencyRateById(this.id).subscribe(response=>{this.currencyRate=response['data'];this.selectedCurrency = response['data'].currency.id;   });  
            this.button_caption="Редактировать";
            this.button_icon="fa fa-edit";

            this.currencyService.getCurrency().subscribe(response=>{this.currencyRate.currencies=response['data'].map(function(value: any){
                  return {label:value.name, value: value.id, code: value.code};
                  });
                  this.loading=false; 
            }); 
    }  

    console.log(this.selectedCurrency);
     console.log('Валюта выбрано');
   




    // this.currencyService.getCurrency().subscribe(response=>{this.currencyRate.currencies=response.data.map(function(value: any){
          // return {label:value.name, value: value.id, code: value.code};
    // });

  
    

    

    // console.log(this.currencyRate.currency_id);
   // this.arrayCurrencyIso=this.currencyRate.currency_id.map(function(value: any){
        // return {id : value.value};
    // });
// console.log(this.arrayCurrencyIso);
  



  // });   

  }

  ngOnInit() {
  	this.currencyRate=[];
    // this._store_id=this.global.user.stores[0].id;
  	// this._store_name=this.global.user.stores[0].name;
  }

  backClicked() {
        this.location.back();
  }

  crud(form: NgForm){
    this.loading=true;   
    console.log(form.value);
        if(!this.id){
             this.currencyRateService.createCurrencyRate(form.value)
             .subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно добавлено"});this.loading=false;console.log(data);});

         }else{
           this.currencyRateService.updateCurrencyRate(form.value,this.id)
             .subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно изменено"});this.loading=false;console.log(data);});
         }

  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/currency_rates/currency-rate-crud/currency-rate-crud.component.ts